<template>
    <header class="header">
        <!--start navbar-->
        <nav @click="link('trocadeoleo.ilub.app')"
            class="navbar navbar-expand-lg fixed-top"
            :style="{'background': (openMenu ? 'linear-gradient(to right, #000033, #02021D)' : 'transparent')}"

            v-bind:class="{
                affix: hasAffix,
                'custom-nav': coloredLogo,
                'bg-transparent': !coloredLogo,
                'white-bg': coloredLogo,
            }"
        >
            <div class="container">

                <router-link class="navbar-brand" to="/">
                    
                    <img src="../../../public/img/logo.svg" width="75" alt="logo" class="img-fluid"/>

                </router-link>

                <button
                    class="navbar-toggler"
                    type="button"
                    @click="mobileNavClicked"
                    v-bind:class="{ collapsed: collapsed }"
                >
                    <span class="ti-menu"></span>
                </button>

                <div
                    class="collapse navbar-collapse main-menu h-auto"
                    v-bind:class="{ show: !collapsed }"
                    id="navbarSupportedContent"
                >
                    <ul class="navbar-nav ml-auto">
                        <li class="nav-item">

                            <a target="_blank" :href="integracao()" class="nav-link page-scroll pb-2 pt-2">

                                Integração

                            </a>

                        </li>
                        <li class="nav-item">

                            <router-link class="nav-link page-scroll pb-2 pt-2" to="/planos" v-scroll-to="'#pricing'">
                                Planos
                            </router-link>

                        </li>
                        <li class="nav-item">

                            <a target="_blank" :href="link()" class="nav-link page-scroll outline-btn-app pb-2 pt-2 pr-2 pl-2" style="border-radius: 20px !important;">

                                Ir para o App

                            </a>

                        </li>
                    </ul>
                </div>
            </div>
        </nav>
        <!--end navbar-->
    </header>
</template>

<script>
export default {
    props: {
        coloredLogo: {
            type: Boolean,
            default: false,
        },  
        openMenu: {
            type: Boolean,
            default: false,
        }
    },
    data: function () {
        return {
            windowTop: 0,
            collapsed: true,
        };
    },
    mounted() {
        window.addEventListener("scroll", this.onScroll);
    },
    beforeDestroy() {
        window.removeEventListener("scroll", this.onScroll);
    },
    methods: {
        onScroll: function () {
            this.windowTop = window.top.scrollY;
        },
        mobileNavClicked: function () {
            this.collapsed = !this.collapsed;
            if(this.$props.openMenu === false){
                this.$props.openMenu = true;
            }else{
                this.$props.openMenu = false;
            }
        },
        link: () => {

            const url = window.location

            const query = new URLSearchParams(url.search).toString()

            const newUrl = window.urlApp + (query ? '?' + query : '')

            return new URL(newUrl).href;

        },
        integracao: () => {

            const url = window.url + 'integracao/documentation'

            return new URL(url).href;

        }
    },
    computed: {
        hasAffix: function () {
            return this.windowTop > 0;
        },
    },
};
</script>